export const InlinePrompts = {
  horizontal: {
    label: "Horizontal",
    value: "horizontal",
    image: "https://assets.redfastlabs.com/images/pulse/prompts/custom/horizontal.png",
  },
  vertical: {
    label: "Vertical",
    value: "vertical",
    image: "https://assets.redfastlabs.com/images/pulse/prompts/custom/vertical.png",
  },
  tile: {
    label: "Tile",
    value: "tile",
    image: "https://assets.redfastlabs.com/images/pulse/prompts/custom/tile.png",
  },
  text: {
    label: "Text",
    value: "text",
    image: "https://assets.redfastlabs.com/images/pulse/prompts/custom/text.png",
  },
};

export const StandalonePrompts = {
  invisible: {
    label: "Invisible",
    value: "invisible",
    image: "https://assets.redfastlabs.com/images/pulse/prompts/custom/invisible.png",
  },
  retention_modal: {
    label: "Pop up",
    value: "retention_modal",
    image: "https://assets.redfastlabs.com/images/pulse/prompts/custom/popup-1.png",
  },
  video: {
    label: "Video",
    value: "video",
    image: "https://assets.redfastlabs.com/images/pulse/prompts/custom/video.png",
  },
  interstitial: {
    label: "Interstitial",
    value: "interstitial",
    image: "https://assets.redfastlabs.com/images/pulse/prompts/custom/interstitial.png",
  },
  widget: {
    label: "Notification",
    value: "widget",
    image: "https://assets.redfastlabs.com/images/pulse/prompts/custom/widget.png",
  },
  email: {
    label: "Email",
    value: "email",
    image: "https://assets.redfastlabs.com/images/pulse/prompts/custom/email.png",
  },
  bottom_banner: {
    label: "Bottom Banner",
    value: "bottom_banner",
    image: "https://assets.redfastlabs.com/images/pulse/prompts/custom/bottom_banner.png",
  },
  scheduled_push: {
    label: "Push",
    value: "scheduled_push",
    image: new URL("../../assets/images/push_preview.svg", import.meta.url).href,
  },
};

export const PromptTypes = { ...InlinePrompts, ...StandalonePrompts };
